var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFineArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#727831",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1 9a.9.9 0 0 1 .9-.9h20a.9.9 0 0 1 .9.9v20a.9.9 0 0 1-.9.9H14a.9.9 0 0 1-.9-.9V9zm1.8.9v18.2h18.2V9.9H14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.12 20.671c.178.283.906 1.602 1.002 1.768.811 1.396 1.528 2.267 2.476 2.74a.9.9 0 0 0 .804-1.61c-.54-.27-1.078-.923-1.723-2.034-.073-.126-.826-1.488-1.037-1.824-.513-.812-.946-1.236-1.642-1.236-.418 0-.752.18-1.072.475-.172.159-.29.295-.55.615l-.105.129c-.127-.343-.26-.839-.39-1.496-.606-3.028-2.148-4.06-3.974-2.211-1.146 1.16-2.513 3.535-4.716 7.989a.9.9 0 0 0 1.614.798c2.104-4.255 3.429-6.556 4.383-7.522.543-.55.56-.54.927 1.3.39 1.946.81 2.903 1.642 3.175.515.168.974.006 1.378-.334.205-.172.34-.326.638-.693.085-.104.149-.182.201-.243.044.061.092.133.143.214zM29 16.9a2.9 2.9 0 1 0 0-5.8 2.9 2.9 0 0 0 0 5.8zm0-1.8a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2zM22 7.4h4a.9.9 0 1 0 0-1.8h-4a.9.9 0 1 0 0 1.8zM17 32.4h14a.9.9 0 1 0 0-1.8H17a.9.9 0 1 0 0 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.65 31.203l-3.5 10a.9.9 0 1 0 1.7.594l3.5-10a.9.9 0 1 0-1.7-.594zM27.85 31.203l3.5 10a.9.9 0 1 1-1.7.594l-3.5-10a.9.9 0 1 1 1.7-.594zM24.9 38.354V31.5a.9.9 0 1 0-1.8 0v6.854a.9.9 0 1 0 1.8 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFineArt);
export default __webpack_public_path__ + "static/media/fine-art.845cbe726984e230e055d2b55eee41f3.svg";
export { ForwardRef as ReactComponent };